import React from "react"
import styled, { keyframes } from "styled-components"
import { getHeaderTheme } from "../config/headerTheme"
import SkeletonLoader from "./SkeletonLoader"

const ButtonLike = ({ handleLike, onNoVoting, loading, processing, hasLiked }) => {
  return (
    <>
      <LikeWrapper>
        <SkeletonLoader
          active={loading}
          width="40%"
          height="150px"
          borderRadius="100px"
          margin="40px auto"
          display="flex"
        >
          <LikeButton
            onClick={handleLike}
            disabled={loading || processing || hasLiked}
            aria-label="Dar like"
            $processing={processing}
          >
            {processing ? (
              <Spinner viewBox="0 0 50 50">
                <circle cx="25" cy="25" r="20" fill="none" />
              </Spinner>
            ) : (
              <HeartIcon viewBox="0 0 24 24">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </HeartIcon>
            )}
          </LikeButton>
        </SkeletonLoader>

        {processing && <ProcessingText>Enviando...</ProcessingText>}
      </LikeWrapper>

      <SkeletonLoader
        active={loading}
        width="40%"
        height="15px"
        borderRadius="15px"
        margin="0 auto"
        display="flex"
      >
        <NoVoteText
          onClick={!processing ? onNoVoting : undefined}
          style={{ opacity: processing ? 0.5 : 1 }}
        >
          Prefiero no valorar
        </NoVoteText>
      </SkeletonLoader>
    </>
  )
}

export default ButtonLike

/* ========= Styled Components ========= */

const LikeWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
  min-height: 160px;
`

const LikeButton = styled.button`
  background: transparent;
  border: none;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.1s ease, opacity 0.2s ease;

  &:hover:not(:disabled) {
    transform: scale(1.04);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: ${({ $processing }) => ($processing ? 1 : 0.6)};
  }
`

const HeartIcon = styled.svg`
  width: 150px;
  height: 150px;
  display: block;
  pointer-events: none;

  path {
    fill: ${() => getHeaderTheme().accent};
  }
`

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
`

const theme = getHeaderTheme();

const Spinner = styled.svg`
  animation: ${rotate} 2s linear infinite;
  width: 50px;
  height: 50px;
  display: block;

  & circle {
    stroke: ${theme.accent};
    stroke-width: 4px;
    stroke-linecap: round;
    animation: ${dash} 1.5s ease-in-out infinite;
  }
`

const ProcessingText = styled.span`
  margin-top: 10px;
  color: ${theme.accent};
  font-weight: 600;
  font-size: 14px;
  animation: fadeIn 0.3s;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

const NoVoteText = styled.p`
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  color: #707070;
  margin-top: 30px;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${theme.accent};
  }
`
